import { useWindowDimensions, ImageBackground, Image } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import React, { useState } from "react";
import { StackScreenProps } from "../../types";
import { Box, ScrollView, Text, Heading, HStack, View } from "native-base";
import Pagination from "../../components/Pagination";
import Header from "../../components/Header";
import Swiper from "react-native-web-swiper";

export type slideItem = {
  title: string;
  intro: string;
  list: string[];
  bgImage: any;
  bottomItems: { title: string; img: any }[];
};

const CropResearch = ({ navigation }: StackScreenProps<"CropResearch">) => {
  const { width, height } = useWindowDimensions();

  const [activeSlide, setActiveSlide] = useState(1);

  const slideItems: slideItem[] = [
    {
      title: "Oil Palm",
      intro:
        "In partnership with NIFOR and IAR&T, three formulations were developed:",
      list: [
        "o South-West (NPK+Mg+Zn+B – 5:11:23:4:0.3:0.2)",
        "o South-East/South South (NPK+Mg+Zn+B – 5:15:26:5:0.3:0.1)",
        "o National (NPK+Mg+Zn+B – 5:12:23:3:0.3:0.1)",
      ],
      bgImage: require("../../assets/crop_research/oilpalm.png"),
      bottomItems: [
        { title: "NIFOR", img: require("../../assets/nifor.png") },
        { title: "IAR&T", img: require("../../assets/iart.png") },
      ],
    },
    {
      title: "Tomato",
      intro:
        "OCP partnered with NIHORT and IAR&T and three formulations were developed:",
      list: [
        "o South (NPK+Mg+Zn+B – 15:10:23:3:0.3:0.1)",
        "o North (NPK+Mg+Zn+B – 14:10:25:3:0.3:0.1)",
        "o National (NPK+Mg+Zn+B – 10:19:17:3:0.3:0.1)",
      ],
      bgImage: require("../../assets/crop_research/tomatoes.png"),
      bottomItems: [
        { title: "NIHORT", img: require("../../assets/nihort.png") },
        { title: "IAR&T", img: require("../../assets/iart.png") },
      ],
    },
    {
      title: "Cocoa",
      intro:
        "In partnership with CRIN, IITA, and FMARD, four fertilizer formulations generated for cocoa production in four regions are:",
      list: [
        "o South-West (NPK+Ca+Mg+B – 5:10:30:20:5:0.85)",
        "o South-South/South-East (NPK+Ca+Mg+B – 5:10:35:28:7:0.95)",
        "o North-Central (NPK+Ca+Mg+B – 5:20:20:15:3:1.05)",
        "o National (NPK+Ca+Mg+B – 5:10:35:18:4:0.85)",
      ],
      bgImage: require("../../assets/crop_research/cocoa.png"),
      bottomItems: [
        { title: "CRIN", img: require("../../assets/crin.png") },
        { title: "IITA", img: require("../../assets/iita.png") },
        { title: "FMARD", img: require("../../assets/fmard.png") },
      ],
    },
    {
      title: "Wheat",
      intro:
        " In Partnership with CDA-BUK, IAR&T, and LCRI, two tested formulations are: ",
      list: [
        "o o(NPK+Mg+S+Zn+B+Mo – 20:20:10:1:0.5:0.3:0.1:0.1)",
        "o (NPK+Mg+S – 20:20:10:1:0.5)",
      ],
      bgImage: require("../../assets/crop_research/wheat.png"),
      bottomItems: [
        { title: "IAR&T", img: require("../../assets/iart.png") },
        { title: "IAR&T", img: require("../../assets/iart.png") },
      ],
    },
    {
      title: "Irish Potatoe",
      intro:
        "In partnership with NRCRI, Plateau State ADP, and FMARD and the tested fertilizer formulation is: ",
      list: ["o NPK+Zn+S+Mg+Cu+B (14+14+20+1+4+2+2+0.2) "],
      bgImage: require("../../assets/crop_research/potatoes.png"),
      bottomItems: [
        { title: "IAR&T", img: require("../../assets/iart.png") },
        { title: "FMARD", img: require("../../assets/fmard.png") },
      ],
    },
    {
      title: "Rice",
      intro:
        "Fertilizer validation trials were conducted in Kebbi and Niger States in partnership with NCRI and the tested formulation is: ",
      list: ["o NPK+S+Zn+B (11:22:21:5:0.7+0.5) "],
      bgImage: require("../../assets/crop_research/rice.png"),
      bottomItems: [{ title: "NCRI", img: require("../../assets/ncri.png") }],
    },
    {
      title: "Soybean",
      intro:
        "OCP partnered with NCRI and Trials were carried out in Kaduna and Benue States and the tested formulation is:",
      list: ["o (NPKS+Zn+B – 8:22:30:4:1:0.2)"],
      bgImage: require("../../assets/crop_research/soybean.png"),
      bottomItems: [{ title: "NCRI", img: require("../../assets/ncri.png") }],
    },
    {
      title: "Sorghum",
      intro:
        "In partnership with IAR, trials were conducted in Katsina, Kano and Kebbi states and two fertilizer formulations were developed for sorghum:",
      list: ["o NPK+S+Zn+B (11:22:21:5:0.7:0.5)", "o NPS+Zn+B (14:31:9:1:1)"],
      bgImage: require("../../assets/crop_research/sorghum.png"),
      bottomItems: [{ title: "NIFOR", img: require("../../assets/nifor.png") }],
    },
    {
      title: "Maize",
      intro:
        "Fertilizer validation trials were concluded in 2018 and launched in 2019. Two formulations were birthed: ",
      list: ["oNPK+S+Zn+B (11:22:21:5:0.7:0.5)", "NPS+Zn+B (14:31:9:1:1)"],
      bgImage: require("../../assets/crop_research/maize.png"),
      bottomItems: [],
    },
    // {
    //   title: "",
    //   intro:
    //     "",
    //   list: [""],
    //   bgImage: require("../../assets/crop_research/sorghum.png"),
    // },
  ];

  const renderItem = ({ item, index }: { item: slideItem; index: number }) => {
    return (
      <Box w={"5/6"} h={400} alignSelf="center">
        <ImageBackground
          source={item?.bgImage}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 35,
            overflow: "hidden",
            borderWidth: 5,
            borderColor: "white",
            padding: 15,
          }}
          imageStyle={{ borderRadius: 15 }}
        >
          <Heading mb="10">{item.title}</Heading>
          <Text>{item?.intro}</Text>
          {item?.list.map((l, i) => (
            <Text key={i} fontSize="xs">
              {l}
            </Text>
          ))}
        </ImageBackground>
      </Box>
    );
  };

  return (
    <ImageBackground
      source={require("../../assets/crop-research-bg.png")}
      resizeMode="cover"
      style={{ width, height, backgroundColor: "#6A3F24ca" }}
    >
      <Box w="full" h="full" style={{ backgroundColor: "rgba(0,0,0,.5)" }}>
        <SafeAreaView style={{ height }}>
          <ScrollView px="5">
            <Header
              onPress={() => navigation.navigate("ResearchAndDev")}
              parentText="Research & Development"
              headingText="CROP RESEARCH"
              intro="Through the Country’s National Research Institutes with crop-specific mandates, OCP has contributed to Nigeria’s agriculture by developing and validating speciality fertilizers for a wide range of crops, with the aim of increasing farmers’ crop yield."
            />

            <Text textAlign="center" fontWeight="bold" mb={16}>
              Some of the projects are as follows:
            </Text>

            <View height={400}>
              <Swiper
                controlsEnabled={false}
                onIndexChanged={(i) => setActiveSlide(i)}
              >
                {slideItems?.map((item, index) => renderItem({ item, index }))}
              </Swiper>
            </View>

            <HStack space={5} mt={5} mb={"16"} justifyContent="center">
              {slideItems[activeSlide + 1]?.bottomItems?.map((item, i) => (
                <Box
                  bg="white"
                  style={{ width: 80, height: 50, borderRadius: 10 }}
                  key={i}
                >
                  <Image
                    source={item.img}
                    style={{ width: 80, height: 50 }}
                    resizeMode="contain"
                  />
                  <Text textAlign={"center"} fontWeight="bold">
                    {item?.title}
                  </Text>
                </Box>
              ))}
            </HStack>
            <Pagination items={slideItems} activeIndex={activeSlide} mt={15} />
          </ScrollView>
        </SafeAreaView>
      </Box>
    </ImageBackground>
  );
};

export default CropResearch;
